import { render, staticRenderFns } from "./ShareLayout2.vue?vue&type=template&id=384b2997&scoped=true&"
import script from "./ShareLayout2.vue?vue&type=script&lang=js&"
export * from "./ShareLayout2.vue?vue&type=script&lang=js&"
import style0 from "./ShareLayout2.vue?vue&type=style&index=0&id=384b2997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b2997",
  null
  
)

export default component.exports